import React from "react";
import SpaPricingImage from "../../Assets/home/SpaPricingImage.png";
import priceImg1 from "../../Assets/home/priceImg1.png";
import priceImg2 from "../../Assets/home/priceImg2.png";
import priceImg3 from "../../Assets/home/priceImg3.png";
import priceImg4 from "../../Assets/home/priceImg4.png";
import priceImg5 from "../../Assets/home/priceImg5.png";
import priceImg6 from "../../Assets/home/priceImg6.png";

const data1 = [
  {
    id: 1,
    priceImg: priceImg1,
    altText: "Manicure Image",
    title: "Manicure & Pedicure",
    price: "₹250",
    description: "20 mins revitalize facial",
  },
  {
    id: 2,
    priceImg: priceImg2,
    altText: "Manicure Image",
    title: "Facials",
    price: "₹250",
    description: "20 mins revitalize facial",
  },
  {
    id: 3,
    priceImg: priceImg3,
    altText: "Manicure Image",
    title: "Massage Therapy",
    price: "₹250",
    description: "20 mins revitalize facial",
  },
];

const data2 = [
  {
    id: 4,
    priceImg: priceImg4,
    altText: "Manicure Image",
    title: "Body Treatments",
    price: "₹250",
    description: "20 mins revitalize facial",
  },
  {
    id: 5,
    priceImg: priceImg5,
    altText: "Manicure Image",
    title: "Hair Removal",
    price: "₹250",
    description: "20 mins revitalize facial",
  },
  {
    id: 6,
    priceImg: priceImg6,
    altText: "Manicure Image",
    title: "Nail Enhancements",
    price: "₹250",
    description: "20 mins revitalize facial",
  },
];

function SpaTreatmentsWithPricing() {
  return (
    <div className="flex flex-col justify-center items-center p-6 pt-4 md:px-16 md:py-8 mt-4">
      <div className="flex flex-col justify-center items-center gap-2">
        <p className="text-base md:text-lg italic text-[#FF8F61]">
          About Pricing
        </p>
        <h1 className="text-[#202020] md:w-[80%] font-serif text-center font-extrabold text-3xl md:text-5xl md:mb-8 leading-tight md:leading-tight">
          Spa Treatments With Pricing
        </h1>
      </div>

      <div className="grid grid-cols-1 mt-2 md:grid-cols-2 lg:grid-cols-[2fr_1fr_2fr]">
        <div className="grid grid-cols-1 gap-4" data-aos="flip-up">
          {data1 &&
            data1.length > 0 &&
            data1?.map((item) => {
              if (item.id % 3 !== 0) {
                return (
                  <>
                    <Card item={item} key={item.id} />
                    <hr className="border-y-1 ml-4 lg:mr-4 border-[#FF8F61]" />
                  </>
                );
              } else {
                return <Card item={item} key={item.id} />;
              }
            })}
        </div>

        <div className="hidden lg:block " data-aos="zoom-in">
          <img
            src={SpaPricingImage}
            alt="Spa Pricing"
            className="md:h-[100%]"
          />
        </div>

        <hr className="border-y-1 ml-4 mt-4 mb-4 md:hidden lg:mr-4 border-[#FF8F61]" />

        <div className="grid grid-cols-1 gap-4" data-aos="flip-up">
          {data2 &&
            data2.length > 0 &&
            data2?.map((item) => {
              if (item.id % 3 != 0) {
                return (
                  <>
                    <Card item={item} key={item.id} />
                    <hr className="border-y-1 ml-4 border-[#FF8F61] lg:mr-4" />
                  </>
                );
              } else {
                return <Card item={item} key={item.id} />;
              }
            })}
        </div>
      </div>
    </div>
  );
}

export default SpaTreatmentsWithPricing;

function Card({ item }) {
  return (
    <div className="grid grid-cols-[1fr_3fr_1fr] gap-4 md:gap-6 items-center p-4">
      <img src={item.priceImg} alt={item.altText} />
      <div
        className="flex flex-col items-start
justify-center"
      >
        <h1 className="text-[#C2775B] text-md md:text-xl xl:text-2xl font-serif font-bold">
          {item.title}
        </h1>
        <p className="text-[#272727] text-sm">{item.description}</p>
      </div>

      <div className="flex items-center justify-center">
        <h1 className="font-bold text-[#272727] text-lg md:text-xl xl:text-2xl md:font-extrabold">
          {item.price}
        </h1>
      </div>
    </div>
  );
}
